import { Box } from '@hopskipdrive/react-components';
import { Text } from '@rideiq/shared/components/Text';
import { variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const RiderName = styled(Text)`
  white-space: nowrap;
  margin-left: 28px;

  ${variables.mediaQuery.lessThan('tablet')`
     margin-left: 18px;
  `}
`;

export const SafetySettings = styled(Box)`
  display: flex;
  flex-direction: column;

  span {
    white-space: nowrap;
  }
`;

export const PrimaryCaregiver = styled(Box)`
  display: flex;

  ${variables.mediaQuery.lessThan('tablet')`
     flex-direction: column;
  `};

  .MuiTypography-root {
    white-space: nowrap;
    ${variables.mediaQuery.lessThan('tablet')`
      margin-left: 0;
    `};
  }
`;
